export function swap(array, a, b){
    let temp = array[a];
    array[a] = array[b];
    array[b] = temp;
    return array;
}